import { AppController } from "../AppController";
var SuccessPage = /** @class */ (function () {
    function SuccessPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(SuccessPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    return SuccessPage;
}());
export { SuccessPage };
